export const runtimeConfig = {
  "id": "cmj38vh4c0001yz01q5tw2sc9",
  "isActive": true,
  "isDefault": true,
  "isMultiCountry": true,
  "isSearchableByCountry": false,
  "isTelegramMiniApp": false,
  "isSubscriptionsEnabled": false,
  "isPhoneRequestOnStartEnabled": true,
  "isCountryAutoAssignmentEnabled": false,
  "isCountryAutoAssignmentIgnored": false,
  "isNoIndex": true,
  "isNoFollow": true,
  "isIndexNowEnabled": false,
  "indexNowKey": null,
  "domain": "stg.doska.tv",
  "appLinksDomain": "a.stg.doska.tv",
  "iosBundleId": null,
  "androidPackageName": null,
  "alias": "DoskaTV",
  "name": {
    "en": "State Doska.tv",
    "he": "State Doska.tv",
    "ru": "State Doska.tv"
  },
  "logoUrl": "https://doskatv-staging-s3-data.s3.eu-central-1.amazonaws.com/2025/11/1763642721806-uvl9x9m42y0bkoq.png",
  "logoAlt": {},
  "countryId": "cmcei05ek0001xr14f394k82t",
  "defaultLanguage": "ru",
  "languages": [
    "ru",
    "en",
    "he"
  ],
  "resultTranslatedLanguages": [],
  "defaultCurrency": "ILS",
  "authMethods": [
    "EMAIL",
    "SMS"
  ],
  "activeSitemapGenerationId": "cmw1jovcf00f6yx1dq1og93e9",
  "createdAt": "2025-12-12T19:12:58.476Z",
  "updateAt": "2026-11-04T03:16:31.543Z",
  "defaultCountry": {
    "id": "cmcei05ek0001xr14f394k82t",
    "currency": "ILS",
    "countryCode": "IL",
    "hasActiveWhiteLabel": true,
    "name": {
      "ru": "Израиль",
      "uz": "Израиль",
      "en": "Israel",
      "he": "ישראל"
    },
    "normalizedName": "israel",
    "phoneCode": "+972",
    "phonePlaceholder": "00-000-0000",
    "inputMask": "055-123-4567",
    "allowedPhoneLengths": [
      9,
      10
    ],
    "authMethods": [
      "EMAIL",
      "SMS"
    ],
    "latitude": 32.0667,
    "longitude": 34.7667
  },
  "countriesWithWhiteLabels": [
    {
      "id": "cmcei05ek0001xr14f394k82t",
      "normalizedName": "israel",
      "whiteLabel": {
        "id": "cmi7fccwe0006x918di7g16qc",
        "isActive": true,
        "isDefault": false,
        "isMultiCountry": false,
        "isSearchableByCountry": true,
        "isTelegramMiniApp": false,
        "isSubscriptionsEnabled": true,
        "isPhoneRequestOnStartEnabled": true,
        "isCountryAutoAssignmentEnabled": false,
        "isCountryAutoAssignmentIgnored": false,
        "isNoIndex": true,
        "isNoFollow": true,
        "isIndexNowEnabled": false,
        "indexNowKey": null,
        "domain": "stg.doskatv.co.il",
        "appLinksDomain": "a.stg.doskatv.co.il",
        "iosBundleId": null,
        "androidPackageName": null,
        "alias": "DoskaTV",
        "name": {
          "en": "Тестовая доска для Израиля",
          "he": "Тестовая доска для Израиля",
          "ru": "Тестовая доска для Израиля"
        },
        "logoUrl": "https://doskatv-production-s3-data.s3.eu-central-1.amazonaws.com/2026/03/1773246475838-lgcdu200m4o1n64.png",
        "logoAlt": {},
        "countryId": "cmcei05ek0001xr14f394k82t",
        "defaultLanguage": "ru",
        "languages": [
          "ru",
          "he",
          "en"
        ],
        "resultTranslatedLanguages": [],
        "defaultCurrency": "ILS",
        "authMethods": [
          "SMS",
          "EMAIL"
        ],
        "activeSitemapGenerationId": "cmw1k8bk400feyx1d98e5gtqe",
        "createdAt": "2025-11-20T12:45:26.223Z",
        "updateAt": "2026-11-04T03:31:44.212Z",
        "defaultCountry": {
          "id": "cmcei05ek0001xr14f394k82t",
          "currency": "ILS",
          "countryCode": "IL",
          "hasActiveWhiteLabel": true,
          "name": {
            "ru": "Израиль",
            "uz": "Израиль",
            "en": "Israel",
            "he": "ישראל"
          },
          "normalizedName": "israel",
          "phoneCode": "+972",
          "phonePlaceholder": "00-000-0000",
          "inputMask": "055-123-4567",
          "allowedPhoneLengths": [
            9,
            10
          ],
          "authMethods": [
            "EMAIL",
            "SMS"
          ],
          "latitude": 32.0667,
          "longitude": 34.7667
        }
      }
    }
  ]
} as const;
